<template>
  <div class="digital-twin-parent">
    <transition name="left">
      <div class="map1" v-show="this.$store.state.map">
        <map1></map1>
      </div>
    </transition>
    <transition name="left">
      <div class="left" v-show="this.$store.state.show">
        <div class="twin-left">
          <div class="distributed1">
            <distributed @viewUncheck="viewUncheck"></distributed>
          </div>
          <div class="resource1">
            <resource></resource>
          </div>
          <div class="monitor1">
            <monitor></monitor>
          </div>
        </div>
      </div>
    </transition>
    <transition name="right">
      <div class="right" v-show="this.$store.state.show">
        <div class="twin-right">
          <div class="guide1">
            <guide></guide>
          </div>
          <div class="report1">
            <reportlive></reportlive>
          </div>
          <div class="participate1">
            <participate></participate>
          </div>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
import distributed from "./components/distributed.vue";
import resource from "./components/resource.vue";
import monitor from "./components/monitor";
import guide from "./components/guide";
import participate from "./components/participate";
import map1 from "./components/MapCom ";
import reportlive from "./components/reportlive";
export default {
  // eslint-disable-next-line vue/no-unused-components
  components: {
    distributed,
    resource,
    monitor,
    guide,
    participate,
    map1,
    reportlive,
  },
  data() {
    return {
      initSuccess: false,
    };
  },
  methods: {
    initSlot() {
      setTimeout(() => {
        this.initSuccess = true;
      }, 1000);
    },
    viewUncheck(){
      
      this.$emit('uncheck');
    }
  },
  created() {
    this.initSlot();
  },
};
</script>
<style scoped>
.left-enter-active,
.left-leave-active {
  transition: all 0.5s;
}
.left-enter, .left-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
  transform: translateX(-17%);
}
.right-enter-active,
.right-leave-active {
  transition: all 0.5s;
}
.right-enter, .right-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
  transform: translateX(17%);
}
.digital-twin-parent {
  width: 100%;
  box-sizing: border-box;
  z-index: 100;
  position: relative;
  top: -6.5vh;
}
.digital-twin-parent::after {
  content: "";
  display: block;
  clear: both;
}
.left {
  height: 100vh;
  background: url("./../../assets/img/left.png") no-repeat;
  background-size: 100%;
  width: 19vw;
  padding-left: 0.125rem;
  position: absolute;
  left: 0rem;
  box-sizing: border-box;
   padding-top: 7.5vh;
}
.right {
  padding-right: 0.125rem;
  height: 100vh;
  background: url("./../../assets/img/right.png") no-repeat;
  background-size: 100% 100%;
  width: 19vw;
  position: absolute;
  right: 0rem;
  box-sizing: border-box;
   padding-top: 7.5vh;
}
.twin-left {
  /* float: left; */
  width: 100%;
  height: 93.5vh;
}
.distributed1 {
  width: 100%;
  height: 25.3vh;
}
.resource1 {
  width: 100%;
  height: 23vh;
  margin-top: 10%;
  margin-top: 0.1rem;
}
.monitor1 {
  height: 40vh;
  width: 100%;
  margin-top: 0.1rem;
}

.twin-right {
  width: 100%;
  box-sizing: border-box;
  height: 93.5vh;
}
.twin-right .guide1 {
  width: 100%;
  height: 32.5vh;
}
.twin-right .participate1 {
  width: 100%;
  height: 28vh;
  margin-top: 0.1rem;
  display: flex;
  justify-content: space-between;
}

.map1 {
  width: 1.7125rem;
  position: absolute;
  left: 0.1rem;
  top: 8.5vh;
  padding: 10px;
  background: rgba(0, 0, 0, 0.5);
  border-radius: 10px;
}
.report1 {
  width: 100%;
  height: 28vh;
  margin-top: 0.1rem;
  display: flex;
  justify-content: space-between;
}
</style>